import {post} from '../script/serviceApiPost';
import {download} from '../script/serviceApiPostDownload';

export default{
  async getData(dataRow: any) {
    // let result=await post("system/UserLogin/login", {dataRow:dataRow});
    // let result=await post("test/getData", dataRow);
    const result = await post('test/getData', dataRow);
    return result;
  },
  async save(dataRow: any) {
    const result = await post('tbPic/save', dataRow);
    return result;
  },
  async edit(dataRow: any) {
    const result = await post('tbPic/edit', dataRow);
    return result;
  },
  async updateByWhere(dataRow: any) {
    const result = await post('tbPic/updateByWhere', dataRow);
    return result;
  },
  async removeByIds(requestParam: any) {
    const result = await post('tbPic/removeByIds', requestParam);
    return result;
  },
  async getPicHost(requestParam: any) {
    const result = await post('tbPic/getPicHost', requestParam);
    return result;
  },
  async downloadFile(requestParam: any) {
    await download('tbPic/downloadFile', requestParam);
  },
   
  async deleteFileByName(dataRow: any) {
    const result = await post('tbPic/deleteFileByName', dataRow);
    return result;
  },
  async checkFile(requestParam: any) {
    const result = await post('tbPic/checkFile', requestParam);
    return result;
  },
  
  
};
